export { LogoMarqueeV2 } from './LogoMarqueeV2';
